// axiosConfig.ts
import axios from "axios";

let _onUnauthorized: (() => void) | null = null;

// Call once at app startup (index.tsx) to register the logout callback
export const setUnauthorizedHandler = (handler: () => void) => {
  _onUnauthorized = handler;
};

// Intercept every 401 and invoke the registered handler
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && _onUnauthorized) {
      _onUnauthorized();
    }
    return Promise.reject(error);
  }
);

const configureAxios = (token: string) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export default configureAxios;
